import ScrollReveal from "../../../components/feature/ScrollReveal";
import { stepsData } from "../../../mocks/firstTimeData";

export default function StepsSection() {
  return (
    <section className="py-16 md:py-24 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12">
              <p className="section-label mb-3">{stepsData.label}</p>
              <h2 className="section-title">{stepsData.title}</h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
            {stepsData.steps.map((step, idx) => (
              <ScrollReveal key={step.num} direction="up" delay={idx * 120}>
                <div className="relative text-center">
                  <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-airdoa-navy text-airdoa-gold mb-5">
                    <i className={`${step.icon} text-2xl`} />
                  </div>
                  <p className="text-5xl font-serif font-bold text-airdoa-gold/20 absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2">
                    {step.num}
                  </p>
                  <h3 className="text-lg font-serif font-semibold text-airdoa-navy">{step.title}</h3>
                  <p className="mt-2 text-sm text-airdoa-gray leading-relaxed">{step.desc}</p>
                  <ul className="mt-4 flex flex-col gap-1">
                    {step.details.map((d) => (
                      <li key={d} className="flex items-center justify-center gap-1.5 text-xs text-airdoa-gray">
                        <span className="w-3.5 h-3.5 flex items-center justify-center text-airdoa-gold">
                          <i className="ri-check-line" />
                        </span>
                        {d}
                      </li>
                    ))}
                  </ul>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}